import { Prop, Schema, SchemaFactory } from '@nestjs/mongoose';
import { Document, Types } from 'mongoose';

export type CouponDocument = Coupon & Document;

export enum CouponType {
  PERCENTAGE = 'percentage',
  FIXED_AMOUNT = 'fixed_amount',
}

@Schema({ timestamps: true })
export class Coupon {
  @Prop({ required: true, unique: true })
  code: string;

  @Prop()
  description: string;

  @Prop({ type: String, enum: CouponType, required: true })
  type: CouponType;

  @Prop({ required: true })
  value: number;

  @Prop()
  minimumOrderAmount: number;

  @Prop()
  maximumDiscountAmount: number;

  @Prop({ required: true })
  usageLimit: number;

  @Prop({ default: 0 })
  usedCount: number;

  @Prop({ required: true })
  expiryDate: Date;

  @Prop()
  startDate: Date;

  @Prop({ default: true })
  isActive: boolean;

  @Prop({ type: [Types.ObjectId], ref: 'Category', default: [] })
  applicableCategories: Types.ObjectId[];

  @Prop({ type: [Types.ObjectId], ref: 'Product', default: [] })
  applicableProducts: Types.ObjectId[];

  @Prop({ type: [Types.ObjectId], ref: 'User', default: [] })
  usedByUsers: Types.ObjectId[];

  @Prop({ default: false })
  isShippingDiscount: boolean;

  isValid(): boolean {
    const now = new Date();
    return (
      this.isActive &&
      (!this.startDate || this.startDate <= now) &&
      (!this.expiryDate || this.expiryDate >= now) &&
      this.usedCount < this.usageLimit
    );
  }
}

export const CouponSchema = SchemaFactory.createForClass(Coupon);

// Indexes for better performance
CouponSchema.index({ code: 1 });
CouponSchema.index({ expiryDate: 1 });
CouponSchema.index({ isActive: 1 });
CouponSchema.index({ startDate: 1, expiryDate: 1 });

